@use '@scss' as *;

@layer module {
.recurring-past-transactions-wrapper {
            display: flex;
            flex-flow: column nowrap;
    }

.recurring-past-transactions-title {
            margin: 0;
    }

.recurring-past-transactions-summary {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
    }

.recurring-past-transactions-back-button {
            align-self: flex-start;
            width: fit-content;
    }
} // layer module










@layer app {
.recurring-past-transactions-wrapper {
            gap: $size-16;
    }

.recurring-past-transactions-summary {
            gap: $size-8;
    }

.recurring-past-transactions-title {
            font-size: var(--font-size-xl);
            font-weight: 600;
            color: var(--text-primary);
    }

.recurring-past-transactions-summary-item {
            font-size: var(--font-size-base);
            color: var(--text-secondary);
    }
} // layer app
